<template>
  <div>
    <ControlPanel :card="false" :icon="'mdi mdi-file'" :title="'Расчётный листок'" :links="links" :premium="true">
      <b-button size="sm" variant="primary" class="mr-1" @click="doPayslip()"><span class="mdi mdi-file-document"></span> Сформировать</b-button>
      <b-button size="sm" variant="dark" @click="Print('printBodyPayslip', 'portrait')"><span class="mdi mdi-printer"></span> Печать</b-button>
    </ControlPanel>

    <div class="row" v-if="user.registered && !user.subscribe_expired">
      <div class="col-md-4">
        <b-card header-class="bg-secondary text-white" class="mb-1">
          <template v-slot:header>
            Параметры
          </template>
          <div class="row">
            <div class="col-md-12">
              <b-form-group>
                <SelectOrg :title="['Организация', 'Организация']" :name="'orgs'" :table="'reg_organizations'"
                           :fields="['name']"></SelectOrg>
              </b-form-group>

              <b-form-group>
                <SelectWorker :title="['Сотрудник', 'Сотрудник']"></SelectWorker>
              </b-form-group>
              <b-form-group>
                <b-input-group size="sm">
                  <template #prepend>
                    <b-input-group-text>Период</b-input-group-text>
                  </template>
                  <Enums :type="'enum'" :name="'months'" v-model="params.period.month"></Enums>
                  <Enums :type="'enum'" :name="'years'" v-model="params.period.year"></Enums>
                </b-input-group>
              </b-form-group>
              <b-form-checkbox value="1" unchecked-value="0" v-model="params.description">Прикрепить расшифровку</b-form-checkbox>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-8">
        <b-card header="Расчётный листок" header-bg-variant="secondary" header-text-variant="white">
          <PrintPayslip :org="org" :worker="worker" :params="params" :result="result"></PrintPayslip>
        </b-card>
      </div>
    </div>

    <Premium v-else />
  </div>
</template>


<script>
import SelectOrg from "@/components/base/SelectOrg"
import SelectWorker from "@/components/base/SelectWorker"
import Enums from "@/components/base/Enums"
import PrintPayslip from "@/components/print/Payslip"
import {mapGetters} from "vuex";
import ControlPanel from "@/components/base/ControlPanel";
import Premium from "@/components/base/Premium"

export default {
  name: 'Payslip',
  components: {
    ControlPanel,
    SelectOrg,
    SelectWorker,
    Enums,
    PrintPayslip,
    Premium
  },
  data: function () {
    return {
      links: [
        {name: 'Справка о заработной плате', link: '/docs/salarycertificate/', icon: 'mdi mdi-file'},
        {name: 'Калькулятор заработной платы', link: '/', icon: 'mdi mdi-calculator'},
      ],
      params: {
        period: {
          month: '0',
          year: new Date().getFullYear()
        },
        description: 0
      },
      result: {
        list: [],
        description: [],
        amount: {
          paid: 0,
          pay: 0,
          sum: 0,
          deduction: 0
        }
      }
    }
  },
  methods: {
    doPayslip: function () {
      this.$store.commit('wait', {state: true, name: 'Формирование расчетного листка'});
      this.$http
          .post(this.$apiold, {
            task: 'salary-payslip',
            params: this.params,
            org: this.org,
            worker: this.worker
          })
          .then(response => {
            this.$store.commit('wait', {state: false});
            this.$store.commit('user', response.data.user);

            this.result = response.data.result;

            // Сообщения
            this.$store.commit('alert', response.data.messages);
          })
    },
    clearResult: function () {
      this.result = {
        list: [],
        description: [],
        amount: {
          paid: 0,
          pay: 0,
          sum: 0,
          deduction: 0
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      org: 'org',
      worker: 'worker',
      user: "user"
    })
  },
  watch: {
    'params.period': {
      handler: function () {
        this.clearResult();
      },
      deep: true
    },
    worker: {
      handler: function () {
        this.clearResult();
      },
      deep: true
    },
    org: {
      handler: function () {
        this.clearResult();
      },
      deep: true
    }
  }
}
</script>


<style>

</style>
